import moment from 'moment';
import { ConditionIcon, DobIcon } from 'src/icons';
import { sanitizeHtmlContent } from 'src/utils';
import Stethoscope from 'src/icons/Stethoscope';
import CalendarExitIcon from 'src/icons/Appointment.icon';
import ProfileGroupIcon from 'src/icons/PatientGroup.icon';
import CalendarNotificationIcon from 'src/icons/CalendarNotificationIcon';

const VCASummaryPrintPreview = ({ record, getUuid }) => {
  const htmlToCopy = record?.llm_intake_summary.replace(/\n/g, '<br>').trim();
  return (
    <div>
      <div className="mb-4 p-2 border border-solid">
        <div className="grid grid-cols-2 gap-2 text-gray-700 text-sm">
          <div className="flex items-center gap-1 text-black">
            <ConditionIcon /> <span className="font-bold">Condition:</span>{' '}
            {getUuid?.appointment_details?.condition_name}
          </div>
          <div className="flex items-center gap-1 text-black">
            <ProfileGroupIcon /> <span className="font-bold">Patient:</span>{' '}
            {getUuid?.patient_details?.first_name}{' '}
            {getUuid?.patient_details?.last_name}
          </div>
          <div className="flex items-center gap-1 text-black">
            <Stethoscope /> <span className="font-bold">Provider:</span>{' '}
            {getUuid?.appointment_details?.practitioner_firstName}{' '}
            {getUuid?.appointment_details?.practitioner_last_name}
          </div>
          <div className="flex items-center gap-1 text-black">
            <CalendarNotificationIcon />{' '}
            <span className="font-bold">Intake Date:</span>{' '}
            {moment(record?.created_at).format('MMM Do, YYYY')}
          </div>

          <div className="flex items-center gap-1 text-black">
            <DobIcon /> <span className="font-bold">Date of Birth:</span>{' '}
            {getUuid?.patient_details?.birth_date}
          </div>

          <div className="flex items-center gap-1 text-black">
            <CalendarExitIcon />
            <span className="font-bold">Appointment Date:</span>{' '}
            {getUuid?.appointment_details?.start_date}
          </div>
        </div>
      </div>

      {htmlToCopy ? (
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtmlContent(htmlToCopy),
          }}
        />
      ) : (
        <div>No medical notes for this encounter</div>
      )}
    </div>
  );
};

export default VCASummaryPrintPreview;
